import { render } from "./ContacteApp.vue?vue&type=template&id=50168309"
import script from "./ContacteApp.vue?vue&type=script&lang=js"
export * from "./ContacteApp.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/projectes/suggestions/suggeriments-upcommons/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__